/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const aiAnalysisRunImages = sqliteTable('ai_analysis_run_images', {
  id: text('id').primaryKey().notNull(),
  analysis_run_id: text('analysis_run_id'),
  encounter_image_id: text('encounter_image_id'),
  filename: text('filename'),
  sort_order: integer('sort_order'),
  created_at: text('created_at'),
});
